module.exports = __webpack_public_path__ + "static/img/piz_bcg.936f5260.png";